import { styled, Theme } from '@material-ui/core';
import { Input, TextInput } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
export const Container = styled('div')<Theme, { active: boolean }>(({ theme, active }) => ({
  background: theme.palette.type === 'dark' ? '#0e1319' : COLORS.WHITE,
  // border: '1px solid #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  borderRadius: 5,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: 15,
  height: 50,
  marginTop: 10,

  '& svg': {
    filter: active ? 'unset' : 'grayscale(100%)',
  },

  '& .prefix': {
    opacity: active ? 1 : 0.5,
  },

  [theme.breakpoints.down('xs')]: {
    height: 70,
  },
}));

export const FlexRow = styled('div')<Theme, { gap?: number; minWidth?: string }>(
  ({ theme, gap = 0, minWidth = 'unset' }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: gap,
    minWidth: minWidth,
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
    },

    '& svg': {
      marginRight: 10,
      height: 23,
      width: 23,
    },
  }),
);

export const FlexMini = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',

  '& > div:first-child': {
    maxWidth: '50%',
    alignItems: 'center',

    [theme.breakpoints.down('xs')]: {
      maxWidth: 'unset',
    },
  },

  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    alignItems: 'unset',

    '& .MuiFormControl-root': {
      margin: 0,
    },
  },
}));

export const CustomTextField = styled(TextInput)({
  '& .MuiInput-underline.Mui-disabled:before': {
    display: 'none',
  },

  '& .MuiInput-underline.Mui-disabled:after': {
    display: 'none',
  },

  height: 25,
  width: '100%',
  fontSize: 14,
  margin: '-5px 10px 0 0',
  textOverflow: 'ellipsis',
  msTextOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  position: 'relative',

  // '& .MuiInput-underline:after': {
  //   content: '"click to edit"',
  //   display: 'block',
  //   border: 'none',
  //   height: 20,
  //   width: 'auto',
  //   fontSize: 14,
  //   transition: 'unset',
  //   marginLeft: 20,
  // },
});

export const FollowerInput = styled(Input)({
  '& .MuiInput-underline.Mui-disabled:before': {
    display: 'none',
  },

  '& .MuiInput-underline.Mui-disabled:after': {
    display: 'none',
  },

  height: 25,
  width: '100%',
  fontSize: 14,
  margin: '-5px 10px 0 0',
  textOverflow: 'ellipsis',
  msTextOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  position: 'relative',
});
